import { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { ScanBarcode } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Scanner = ({ onCode }) => {
  const video = useRef(null);
  const cb = useRef(onCode);
  cb.current = onCode;
  const [err, setErr] = useState("");
  useEffect(() => {
    let ctl;
    let done = false;
    new BrowserMultiFormatReader().decodeFromConstraints({ video: { facingMode: "environment" } }, video.current, (res, _e, c) => {
      ctl = c;
      if (res && !done) { done = true; if (navigator.vibrate) navigator.vibrate(80); c.stop(); cb.current(res.getText()); }
    }).then((c) => { ctl = c; }).catch(() => setErr("Fotocamera non disponibile: concedi il permesso alla fotocamera nel browser."));
    return () => ctl?.stop();
  }, []);
  return (
    <div>
      <div className="relative overflow-hidden rounded-xl bg-black">
        <video ref={video} className="h-72 w-full object-cover" muted playsInline data-testid="barcode-video" />
        <div className="pointer-events-none absolute inset-x-8 top-1/2 h-0.5 -translate-y-1/2 bg-rose-500 shadow-[0_0_12px_#f43f5e]" />
      </div>
      <p className="mt-2 text-sm text-slate-600">{err || "Inquadra il codice a barre: la lettura è automatica."}</p>
    </div>
  );
};

export const ScanButton = ({ onCode, testid = "scan-barcode-button", label = "Scansiona" }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" className="h-11 bg-white" data-testid={testid} onClick={() => setOpen(true)}><ScanBarcode className="mr-2 h-4 w-4" />{label}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="barcode-dialog">
          <DialogHeader><DialogTitle>Leggi codice a barre</DialogTitle></DialogHeader>
          {open && <Scanner onCode={(c) => { setOpen(false); onCode(c); }} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
